import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { socket } from 'api';
import { user } from 'services/user';
import { openWindow } from 'store/actions/windows';
import { Img } from '../img/img';
import { Plate } from './plate';
import { GrayButton } from '../../../../../src/components/buttons';
import { getPhotoUrl } from './items.func';
import { Content, Title, PhotoPlace, Refresh, ButtonWrapper } from './item.styled';

export const Item = (props) => {
  const { t } = useTranslation();
  const { id, item, source, refreshPhotoButton, refreshPlateButton } = props;
  const { title, photo, photo64, plate, refresh, departure, stayId, changeMethod, withoutChange } = item;
  const [error, setError] = useState(!photo && !photo64);
  const [photoOk, setPhotoOk] = useState(photo);
  const [photoOk64, setPhotoOk64] = useState(photo64);
  const [loading, setLoading] = useState(false);
  const [working, setWorking] = useState(false);
  const dispatch = useDispatch();

  const afterSetPlate = () => {
    setLoading(false);
  };

  const getRackPhoto = (msg) => {
    if (msg.target === source) {
      setPhotoOk64(msg.content ? msg.content : msg.photo ? getPhotoUrl(msg.photo) : '-');
      setError(false);
    }
  };

  useEffect(() => {
    setError(!photo && !photo64);
    setPhotoOk(photo);
    setPhotoOk64(photo64);
    setLoading(false);
  }, [id]);

  useEffect(() => {
    socket.on('set_vehicle_plate', afterSetPlate);
    socket.on('passages.set_vehicle_plate', afterSetPlate);
    socket.on('error', afterSetPlate);
    socket.on('racks.get_photo', getRackPhoto);
    return () => {
      socket.off('set_vehicle_plate', afterSetPlate);
      socket.off('passages.set_vehicle_plate', afterSetPlate);
      socket.off('error', afterSetPlate);
      socket.off('racks.get_photo', getRackPhoto);
    };
  }, []);

  const showFoto = (photo, title) => {
    dispatch(
      openWindow({
        id: 'foto',
        type: 'foto',
        data: photo,
        header: title,
      })
    );
  };

  const changePlate = (value) => {
    setLoading(true);
    if (departure || !changeMethod) {
      socket.call('set_vehicle_plate', { target: source, vehicle_plate: value });
    } else {
      socket.call('passages.set_vehicle_plate', { passage_id: stayId, vehicle_plate: value });
    }
  };

  const afterError = () => {
    setError(true);
  };

  /**
   * refresh photo
   * @param {*} event
   */
  const refreshPhoto = (event) => {
    event.stopPropagation();
    socket.call('racks.get_photo', { target: source, user_id: user.getId(), content: true });
  };

  /**
   * refresh plate
   * @returns
   */
  const refreshPlate = () => {
    if (working) {
      return;
    }
    setWorking(true);
    const msg = { target: source, user_id: window.user.getId() };
    socket.call('run_recognition', msg);

    setTimeout(() => {
      setWorking(false);
    }, 500);
  };

  const src = photoOk64 ? 'data:image/png;base64,' + photoOk64 : photoOk;
  const cl = error ? 'error' : '';

  const rightControl = window.haveRight('mnemo.rack_control');

  return (
    <>
      {!refreshPlateButton && (
        <ButtonWrapper>
          <GrayButton disabled={!rightControl} className={working ? 'loading' : ''} onClick={refreshPlate}>
            <img src="/images/rebut.png" alt="" />
            {t('buttons.Обновить ГРЗ')}
          </GrayButton>
        </ButtonWrapper>
      )}

      <Content>
        <Title>{title}</Title>
        <PhotoPlace onClick={() => !error && showFoto(src, title)} className={cl}>
          {(refresh || refreshPhotoButton) && <Refresh onClick={refreshPhoto} />}
          {!error && <Img height={270} src={src} title="..." afterError={afterError} />}
        </PhotoPlace>
        {item.method !== 'vehicle_class_not_match_mean' && !withoutChange && <Plate id={id} loading={loading} value={plate} change={changePlate} />}
      </Content>
    </>
  );
};
